import handleTextChange from '../../utils/handleTextChange';
import { useEffect, useMemo, useState } from 'react';
import './supportAssistance.css';
import Pagination from '../../components/pagination/Pagination';
import ReactLoading from 'react-loading';
import { getSupportInfo, searchCount, sendMessage, submitTicket } from './supportAssistanceFun/supportAssistancefun';
import Dialog from '../../components/dialogModal/dialogModal';
import { ReactComponent as Close } from '../../assets/icons/trvto_close.svg';
import TableContent from '../../components/tripStrap/tableContent';

export default function SupportAssistance() {
    const [modal, setModal] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [offSet, setOffSet] = useState(0);
    const [searchText, setSearchText] = useState('');
    const [tableData, setTableData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [rowData, setRowData] = useState({});
    const [ticketComment, setTicketComment] = useState('');
    const [selectedType, setSelectedType] = useState('');
    const [totalCount, setTotalCount] = useState(0);
    const [isSearch, setIsSearch] = useState(false);
    const totalData = totalCount;
    const [limit, setLimit] = useState(10);
    const [showTicketInfo, setShowTicketInfo] = useState(false);
    const [ticketInfo, setTicketInfo] = useState({});
    // const limit = 10;
    const tableHeader = [
        'Name',
        'Phone Number',
        'Email ID',
        // 'Customer ID',
        'Place Name',
        // 'Location',
        'Date & Time',
        // 'Time of Booked',
        // 'Type',
        // 'Number of People',
        'Price',
        'Organizer Name',
        // 'Pickup Location',
        'Action'
    ];

    useEffect(() => {
        if (!selectedType || searchText.length < 10 || !isSearch) return;
        searchCount(setTotalCount, selectedType, searchText);
    }, [selectedType, searchText, isSearch]);

    useEffect(() => {
        setLimit((prev) => prev);
    }, []);

    const paginationClick = (number, offSetNumber) => {
        if (Math.ceil(totalData / limit) > 1) {
            setPageNumber(+number);
            setOffSet(+offSetNumber);
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    };

    console.log(limit, offSet, isSearch);

    useEffect(() => {
        if (!selectedType || searchText.length < 10 || !isSearch) return;
        const timer = setTimeout(() => {
            getSupportInfo(selectedType, searchText, setTableData, setLoading, limit, offSet);
        }, 300);

        return () => clearTimeout(timer);
    }, [selectedType, searchText, limit, offSet, isSearch]);

    // const handleSearch = () => {
    //     getSupportInfo(selectedType, searchText, setTableData, setLoading, limit, offSet);
    // };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            getSupportInfo(selectedType, searchText, setTableData, setLoading);
        }
    };

    const handleTicketSave = () => {
        const data = {
            userId: rowData.userId._id,
            packId: rowData.packId._id,
            packDateId: rowData.packDateId._id,
            bookingId: rowData._id,
            type: selectedType,
            status: 'in_progress',
            description: ticketComment,
            comments: [
                // {
                //     comment: ticketComment,
                //     name: localStorage.getItem('supName'),
                //     by: localStorage.getItem('supId'),
                //     at: new Date()
                // }
            ],
            assignedTo: localStorage.getItem('supId')
        };
        submitTicket(selectedType, data, setLoading, setModal, setTicketComment);
    };

    const ticketData = [
        {
            label: 'Type',
            answer: Array.isArray(ticketInfo?.packId?.quickView?.type)
                ? ticketInfo.packId.quickView.type.join(', ')
                : (ticketInfo?.packId?.quickView?.type ?? 'N/A')
        },
        {
            label: 'Duration',
            answer: ticketInfo?.packId?.quickView?.duration ?? 'N/A'
        },
        {
            label: 'Trek Distance',
            answer: ticketInfo?.packId?.quickView?.trekDistance ?? 'N/A'
        },
        {
            label: 'Difficulty',
            answer: ticketInfo?.packId?.quickView?.difficulty ?? 'N/A'
        },
        {
            label: 'Stay',
            answer: ticketInfo?.packId?.quickView?.stay ?? 'N/A'
        },
        {
            label: 'Base Cities',
            answer: ticketInfo?.packId?.quickView?.baseCities ?? 'N/A'
        },
        {
            label: 'Pickup Location',
            answer: ticketInfo?.pickupLocation ?? 'N/A'
        },
        {
            label: 'Transport',
            answer: ticketInfo?.transport ?? 'N/A'
        },
        {
            label: 'Total Seats Booked',
            answer: ticketInfo?.totalSeats ?? 'N/A'
        }
    ];

    return (
        <>
            {loading && (
                <div className='loadingBackground'>
                    <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                </div>
            )}
            <div className='supFilter'>
                <h1 className='supportHeader'>Customer Support</h1>
            </div>
            <div className='supportAssContainer'>
                <div className='supportSearchContainer'>
                    <div className='supportAssSearchDiv'>
                        <select
                            name='date'
                            id='date'
                            className='supportAssistSelect select mr-2'
                            onChange={(e) => setSelectedType(e.target.value)}
                        >
                            <option value=''>Choose search type</option>
                            <option value='trip'>Trip</option>
                            <option value='guide'>Guide</option>
                            <option value='camp'>Camp</option>
                        </select>
                        <div className='supAssdivider' />
                        <input
                            placeholder='Search by phone number....'
                            maxLength={10}
                            onChange={(e) => handleTextChange(e, setSearchText)}
                            value={searchText}
                            onKeyDown={handleKeyDown}
                            className='supportAssSearchInput'
                        />
                        <button
                            onClick={() => {
                                setIsSearch(true);
                            }}
                            className='supportAssSearchBtn blueBtn'
                        >
                            Search
                        </button>
                    </div>
                    {/* <div className="supportAssResultDiv">
                Search key word Search result
                <div>Customer Details</div>
                <div>
                    Bookings
                    <div>
                        Each booking will contain - Booking Id, name, no. of
                        peolpe, price, booked on, trip on, email, phone number,
                        Resend details button, comment, payment details, raise
                        ticket,
                    </div> */}
                    {/* To send email and msg once more for particular package */}
                    {/* <button>Send Email/Msg</button>
                </div>
            </div> */}
                </div>
                {tableData.length > 0 && (
                    <>
                        <h4 className='supportAssLabel'>Search Result</h4>
                        <div className='tableContainer'>
                            <table className='table'>
                                <thead className='tableHead'>
                                    <tr>
                                        {tableHeader.map((head, headIndex) => {
                                            return <th key={headIndex}>{head}</th>;
                                        })}
                                    </tr>
                                </thead>
                                <tbody>
                                    {tableData?.map((row, rowIndex) => {
                                        return (
                                            <tr
                                                key={rowIndex}
                                                className='tableBodyRow allowCLick'
                                                onClick={() => {
                                                    setTicketInfo(row);
                                                    setShowTicketInfo(true);
                                                }}
                                            >
                                                <td>{row?.userId?.name ?? 'N/A'}</td>
                                                <td>{row?.userId?.phoneNumber ?? 'N/A'}</td>
                                                <td>{row?.userId?.emailId ?? 'N/A'}</td>
                                                {/* <td>{row.customerId}</td> */}
                                                <td>{row?.packId?.title ?? 'N/A'}</td>
                                                {/* <td>{row.location}</td> */}
                                                <td>
                                                    {row?.packDateId?.startDate?.split('T')[0] +
                                                        ',' +
                                                        row?.packDateId?.startDate?.split('T')[1].split('.')[0] ??
                                                        'N/A'}
                                                </td>
                                                {/* <td>{row.bookingTime}</td> */}
                                                {/* <td>
                                                    {Array.isArray(row?.packId?.quickView?.type)
                                                        ? row.packId.quickView.type.join(', ')
                                                        : (row?.packId?.quickView?.type ?? 'N/A')}
                                                </td> */}
                                                {/* <td>{row?.userDetails?.length ?? 'N/A'}</td> */}
                                                <td>{row?.amountPerSeat ?? 'N/A'}</td>
                                                <td>{row?.packId?.organizerName ?? 'N/A'}</td>
                                                {/* <td>{row?.pickupLocation ?? 'N/A'}</td> */}
                                                <td className='accBtnContainer'>
                                                    <button
                                                        className='actBtn payoutBtn'
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            sendMessage(selectedType, row._id, setLoading);
                                                        }}
                                                    >
                                                        Send Email/Msg
                                                    </button>
                                                    <button
                                                        className='actBtn billBtn'
                                                        onClick={(e) => {
                                                            setModal(true);
                                                            setRowData(row);
                                                            e.stopPropagation();
                                                        }}
                                                    >
                                                        Create Ticket
                                                    </button>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                            <div className='responsiveCardContainer'>
                                {tableData?.map((row, rowIndex) => (
                                    <div
                                        key={rowIndex}
                                        className='responsiveCard'
                                        onClick={() => {
                                            setTicketInfo(row);
                                            setShowTicketInfo(true);
                                        }}
                                    >
                                        <div className='cardContent'>
                                            <p>
                                                <strong>{tableHeader[0]}</strong> {row?.userId?.name ?? 'N/A'}
                                            </p>
                                            <p>
                                                <strong>{tableHeader[1]}</strong> {row?.userId?.phoneNumber ?? 'N/A'}
                                            </p>
                                            <p>
                                                <strong>{tableHeader[2]}</strong> {row?.userId?.emailId ?? 'N/A'}
                                            </p>
                                            {/* <p>
                                            <strong>{tableHeader[3]}</strong>{' '}
                                            {row.customerId}
                                        </p> */}
                                            <p>
                                                <strong>{tableHeader[3]}</strong> {row?.packId?.title ?? 'N/A'}
                                            </p>
                                            {/* <p>
                                            <strong>{tableHeader[5]}</strong>{' '}
                                            {row.location}
                                        </p> */}
                                            <p>
                                                <strong>{tableHeader[4]}</strong>{' '}
                                                {row?.bookedTrip?.startDate?.split('T')[0] ?? 'N/A'}
                                            </p>
                                            {/* <p>
                                            <strong>{tableHeader[7]}</strong>{' '}
                                            {row.bookingTime}
                                        </p> */}
                                            {/* <p>
                                                <strong>{tableHeader[8]}</strong>{' '}
                                                {Array.isArray(row?.packId?.quickView?.type)
                                                    ? row.packId.quickView.type.join(', ')
                                                    : (row?.packId?.quickView?.type ?? 'N/A')}
                                            </p> */}
                                            {/* <p>
                                                <strong>{tableHeader[9]}</strong> {row?.userDetails?.length ?? 'N/A'}
                                            </p> */}
                                            <p>
                                                <strong>{tableHeader[5]}</strong> {row?.amountPerSeat ?? 'N/A'}
                                            </p>
                                            <p>
                                                <strong>{tableHeader[6]}</strong> {row?.packId?.organizerName ?? 'N/A'}
                                            </p>
                                            {/* <p>
                                                <strong>{tableHeader[12]}</strong> {row?.pickupLocation ?? 'N/A'}
                                            </p> */}
                                            <div className='accBtnContainer'>
                                                <button
                                                    className='actBtn payoutBtn'
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        sendMessage(selectedType, row._id, setLoading);
                                                    }}
                                                >
                                                    Send Email
                                                </button>
                                                <button
                                                    className='actBtn billBtn'
                                                    onClick={(e) => {
                                                        setModal(true);
                                                        e.stopPropagation();
                                                    }}
                                                >
                                                    Create Ticket
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        {tableData.length > 0 && (
                            <Pagination
                                paginationClick={paginationClick}
                                numberOfRows={totalData}
                                offSet={offSet}
                                pageNumber={pageNumber}
                                limit={limit}
                            />
                        )}
                    </>
                )}
                {modal && (
                    <Dialog openModal={modal} heading={'Create Ticket'}>
                        <div className='dialogContent'>
                            <p className='ticketTitle'>Name of Booking</p>
                            <p className='ticketContent'>{rowData?.userId?.name ?? 'N/A'}</p>
                            <p className='ticketTitle'>Booking ID</p>
                            <p className='ticketContent'>{rowData?.packId?._id ?? 'N/A'}</p>
                            <p className='ticketTitle'>Date</p>
                            <p className='ticketContent'>{rowData?.packDateId?.startDate?.split('T')[0] ?? 'N/A'}</p>
                            <p className='ticketTitle'>Comment</p>
                            <textarea
                                className='ticketComment'
                                value={ticketComment}
                                onChange={(e) => setTicketComment(e.target.value)}
                            />
                            <div className='alignCenter'>
                                <button
                                    className='dialogActBtn cancel'
                                    onClick={() => {
                                        setModal(false);
                                        setTicketComment('');
                                    }}
                                >
                                    Cancel
                                </button>
                                <button className='dialogActBtn submit' onClick={handleTicketSave}>
                                    Submit
                                </button>
                            </div>
                        </div>
                    </Dialog>
                )}
                {showTicketInfo && (
                    <div
                        className='ratingModal bookingModal'
                        onClick={(e) => {
                            e.stopPropagation();
                            setShowTicketInfo(false);
                        }}
                    >
                        <div className='modalHeader'>
                            Ticket Info
                            <Close className='iconSize' />
                        </div>
                        <div className='modalContent'>
                            <TableContent data={ticketData} />
                        </div>
                    </div>
                )}
            </div>
        </>
    );
}
